import {
  AuthorizationAPIClient,
  AuthorizationSSOAPIClient, AuthorizationSSOModel,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import {
  PermissionExtraParameters,
  PermissionSSORedirectStorage,
  PermissionSSOService,
  PermissionSSOView,
  PermissionStorage,
} from 'frontcore/domain/authorization/model/PermissionService.d'
import {
  ProfileRequestService,
} from 'frontcore/domain/profile/model/Profile.d'

export default class PermissionSSOServiceImpl implements PermissionSSOService {

  readonly #authorizationAPIClient: AuthorizationAPIClient
  readonly #permissionSSORedirectStorage: PermissionSSORedirectStorage
  readonly #permissionStorage: PermissionStorage
  readonly #profileService: ProfileRequestService
  readonly #redirectAPIClient: AuthorizationSSOAPIClient
  readonly #view: PermissionSSOView

  constructor (
    authorizationAPIClient: AuthorizationAPIClient,
    permissionSSORedirectStorage: PermissionSSORedirectStorage,
    permissionStorage: PermissionStorage,
    redirectAPIClient: AuthorizationSSOAPIClient,
    profileService: ProfileRequestService,
    view: PermissionSSOView
  ) {
    this.#authorizationAPIClient = authorizationAPIClient
    this.#permissionSSORedirectStorage = permissionSSORedirectStorage
    this.#permissionStorage = permissionStorage
    this.#profileService = profileService
    this.#view = view
    this.#redirectAPIClient = redirectAPIClient
    this.#redirectAPIClient.addListener(this.onModelChangeListener)
  }

  ssoLogin (extraParameters?: PermissionExtraParameters): void {
    this.#permissionSSORedirectStorage.set()
    if (extraParameters) {
      this.#permissionStorage.set(extraParameters)
    } else {
      this.#permissionStorage.clear()
    }
    this.#redirectAPIClient.login()
  }

  onModelChangeListener = (model: AuthorizationSSOModel): void => {
    (async () => { await this.onModelChange(model) })()
  }

  onModelChange = async (model: AuthorizationSSOModel): Promise<void> => {
    const extraParameters = this.#permissionStorage.get()
    this.#permissionStorage.clear()
    if (!model.isAuthenticated) {
      this.#view.didFulfillLogin({ error: 'common.errors.redirect_sso' })
      return
    }
    const payload = {
      access_token: model.accessToken ?? '',
      id_token: model.idToken ?? '',
      ...extraParameters,
    }
    delete payload.storage
    try {
      const token = await this.#authorizationAPIClient.login(payload)
      const profile = await this.#profileService.retrieve(token)
      this.#view.didFulfillLogin({ extraParameters, profile })
    } catch (e) {
      if (e instanceof Error) {
        this.#view.didFulfillLogin({ error: e.message })
        return
      }
      throw e
    }
  }

}
